import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "28",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.827 5.227c2.13 0 3.855 1.739 3.855 3.884v13.582c0 1.785-.939 1.809-.963 1.809 0 0-1.656-1.817-2.892-1.809-1.185.008-2.058.922-3.056 1.449-.91.48-.689.48-1.6 0-.996-.527-1.868-1.44-3.054-1.449-1.235-.008-1.911 1.1-2.891 1.809 0 0-.964 0-.964-1.809v-8.726c.012-.006.963-.438.964-.97 0-.537-.964-.973-.964-.973V9.111c0-2.145 1.726-3.884 3.855-3.884zM8.117 13.9a.964.964 0 0 0 0 1.928h3.533c.71 0 1.285-.575 1.285-1.285a.643.643 0 0 0-.642-.643zm0-3.855a.964.964 0 0 0 0 1.928h7.389c.71 0 1.285-.576 1.285-1.286a.643.643 0 0 0-.643-.642z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15.178 2.336H11.48c-1.493 0-3.363.964-3.363 2.267.462-.218.975-.34 1.514-.34h7.396c2.042 0 3.62 1.74 3.62 3.885v11.536c0 1.927.963 1.927.963 1.927s.964 0 .964-1.808V6.22c0-2.146-1.656-3.885-3.698-3.885z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }